import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const PurdueUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Purdue University"
      universityShortName="Purdue"
      slug="purdue-university"
      seoTitle="Purdue Study Rooms | WALC and Library Study Spaces West Lafayette"
      seoDescription="Find study rooms at Purdue including WALC and Hicks Library. Learn booking policies and discover CSW as an online alternative."
      seoKeywords="Purdue study rooms, WALC study rooms, Purdue library, West Lafayette study spaces, Boilermaker study rooms"
      canonicalUrl="/study-room/purdue-university/"
      heroDescription="Explore Purdue's modern WALC facility and traditional library study spaces."
      libraryWebsiteUrl="https://www.lib.purdue.edu"
      libraryWebsiteName="Purdue Libraries"
      studySpaces={[
        {
          name: "Wilmeth Active Learning Center (WALC)",
          features: "Rooms seat 6-8, reservable up to 9 hours/week per person.",
          feedback: "Modern facility. Some complaints about people socializing loudly."
        },
        {
          name: "Hicks Undergraduate Library - Basement",
          features: "Quiet study area, individual desks and carrels.",
          feedback: "Good for focused undergraduate work. Less crowded."
        },
        {
          name: "STEW Center",
          features: "Informal study spots, collaborative atmosphere.",
          feedback: "Good alternative when libraries are full."
        },
        {
          name: "Math Sciences Library",
          features: "Graduate student carrels, specialized quiet space.",
          feedback: "Excellent for grad students and math-focused work."
        }
      ]}
      guideContent={
        <>
          <p>
            Purdue's libraries list study rooms by location; many are first-come, first-served, while others are reservable. 
            Rooms in the Wilmeth Active Learning Center (WALC) seat 6-8 students and may be reserved for up to nine hours 
            per week per person.
          </p>
          <p className="mt-4">
            Students sometimes complain about people socializing loudly in study rooms and emphasize that the spaces 
            are meant for studying. The campus also offers numerous informal spots.
          </p>
          <p className="mt-4">
            Reserve WALC rooms for extended group work (up to nine hours per week), but be respectful of the noise policy. 
            Quiet study can be found in Hicks Undergraduate Library's basement or the graduate student carrels in the 
            Math Sciences Library.
          </p>
        </>
      }
      summaryTips={[
        "WALC allows up to 9 hours/week reservations",
        "Some rooms are first-come, first-served",
        "Hicks basement is quieter for undergrads",
        "Math Sciences Library good for grad students",
        "Respect noise policies in all study rooms"
      ]}
    />
  );
};

export default PurdueUniversity;
